import { render, staticRenderFns } from "./EmployeeModal.vue?vue&type=template&id=19f55c25"
import script from "./EmployeeModal.vue?vue&type=script&lang=js"
export * from "./EmployeeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports